import { fmtEur, BILLINGS, billingPeriodCost, monthlyValue } from "@/lib/api";

const ORDER = ["mensile", "trimestrale", "annuale", "una_tantum"];

export default function SubscriptionsSummary({ items }) {
  const active = items.filter((s) => !["sospeso", "scaduto"].includes(s.status));
  if (!active.length) return null;
  const groups = ORDER.map((b) => {
    const subs = active.filter((s) => s.billing === b);
    return { billing: b, count: subs.length, total: subs.reduce((a, s) => a + billingPeriodCost(s), 0) };
  }).filter((g) => g.count);
  const monthly = active.filter((s) => s.billing !== "una_tantum").reduce((a, s) => a + monthlyValue(s), 0);
  return (
    <div className="mt-4 flex flex-wrap items-stretch gap-3" data-testid="subscriptions-summary">
      {groups.map((g) => (
        <div key={g.billing} className="min-w-[170px] flex-1 rounded-md border border-slate-800 bg-slate-900/50 px-4 py-3" data-testid={`summary-${g.billing}`}>
          <div className="text-[11px] uppercase tracking-[0.18em] text-slate-500">
            {g.billing === "una_tantum" ? "Una tantum" : `Pagamento ${BILLINGS[g.billing].toLowerCase()}`}
          </div>
          <div className="mt-1 font-mono text-xl text-slate-100" data-testid={`summary-${g.billing}-total`}>{fmtEur(g.total)}</div>
          <div className="text-[11px] text-slate-500">{g.count} {g.count === 1 ? "servizio" : "servizi"}{g.billing !== "una_tantum" && ` · per ${BILLINGS[g.billing].toLowerCase() === "mensile" ? "mese" : BILLINGS[g.billing].toLowerCase() === "trimestrale" ? "trimestre" : "anno"}`}</div>
        </div>
      ))}
      <div className="min-w-[190px] flex-1 rounded-md border border-blue-500/30 bg-blue-500/10 px-4 py-3" data-testid="summary-monthly">
        <div className="text-[11px] uppercase tracking-[0.18em] text-blue-300">Equivalente mensile</div>
        <div className="mt-1 font-mono text-xl text-slate-100" data-testid="summary-monthly-total">{fmtEur(monthly)}</div>
        <div className="text-[11px] text-slate-400">{fmtEur(monthly * 12)} / anno · {active.length} servizi attivi</div>
      </div>
    </div>
  );
}
